module.exports = __webpack_public_path__ + "img/icon-face.699dbc07.svg";